<template>
    <form @submit.prevent="submit" class="search-filters position-relative">
        <div class="text-center d-flex">
            <div class="p-2 bg-white rounded-top-4 mx-auto overflow-x-auto">
                <div class="hstack bg-mercury p-2 rounded-4 gap-3 overflow-x-auto inset-shadow">
                    <div class="position-relative">
                        <input type="radio" class="btn-check" id="radio-for-sale" name="car_type" value="car-for-sale" autocomplete="off" v-model="searchFilters.type" @change="changeVehicleType()" checked>
                        <label class="btn hover-apocalyptic-orange ff-dsb rounded-3 px-sm-4 px-3 text-nowrap" for="radio-for-sale">Cars For Sale</label>
                    </div>
                    <div v-if="!$page.props.user?.is_agent" class="position-relative">
                        <input type="radio" class="btn-check" id="radio-lease-go" name="car_type" value="car-for-lease-and-go" autocomplete="off" v-model="searchFilters.type" @change="changeVehicleType()">
                        <label class="btn hover-apocalyptic-orange ff-dsb rounded-3 px-sm-4 px-3 text-nowrap" for="radio-lease-go">Lease & Go</label>
                    </div>
                    <div v-if="!$page.props.user?.is_agent" class="position-relative">
                        <input type="radio" class="btn-check" id="radio-for-rent" name="car_type" value="car-for-rent" autocomplete="off" v-model="searchFilters.type" @change="changeVehicleType()">
                        <label class="btn hover-apocalyptic-orange ff-dsb rounded-3 px-sm-4 px-3 text-nowrap" for="radio-for-rent">Cars For Rent</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-white rounded-bottom-4 p-3 shadow-sm vstack gap-3">
            <div class="input-group ">
                <input type="text" class="form-control rounded-4" v-model="searchFilters.keyword" placeholder="What car are you searching for?">
                <button class="btn btn-outline-custom d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#search-filter" aria-controls="search-filter">Filter <i class="fal fa-sliders-h"></i></button>
            </div>
            <div class="row g-3">
                <div class="col-xl">
                    <div class="offcanvas-lg offcanvas-end flex-grow-1" id="search-filter" data-bs-scroll="false" tabindex="-1">
                        <div class="offcanvas-header shadow-sm z-1">
                            <h5 class="ff-dsb text-primary">Filter</h5>
                            <div class="close ms-auto" data-bs-dismiss="offcanvas" data-bs-target="#search-filter">
                                <i class="far fa-times fs-18"></i>
                            </div>
                        </div>
                        <div class="offcanvas-body">
                            <div class="row flex-grow-1 g-3">
                                <div class="col-lg-2">
                                    <div class="seperator">
                                        <!-- <Link v-for="make in $page.props.makes" :href="route('front.vehicles.index')" :data="{ make: make.name}" :only="['vehicles']" as="button">{{ make.name }}</Link> -->
                                        <label for="select-make" class="fs-sm-18 fs-16 text-black ff-dsm mb-2">Select Make</label>
                                        <!-- <select id="select-make" class="form-select" v-model="searchFilters.make">
                                        <option selected value="">Make</option>
                                        <option v-for="make in $page.props.makes">{{ make.name }}</option>
                                        </select> -->
                                        <Multiselect v-model="searchFilters.make" :searchable="true" :options="$page.props.makes" label="name" placeholder="Make" valueProp="slug" @select="makesSelect" @clear="makesClear"></Multiselect>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <div class="seperator">
                                        <label for="select-model" class="fs-sm-18 fs-16 text-black ff-dsm mb-2">Select Model</label>
                                        <!-- <select id="select-model" class="form-select" v-model="searchFilters.model">
                                            <option selected value="">Model</option>
                                            <option v-for="model in $page.props.models">{{ model.name }}</option>
                                        </select> -->
                                        <Multiselect v-model="searchFilters.model" :options="models" label="name" placeholder="Model" valueProp="slug"></Multiselect>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <div class="seperator">
                                        <label for="select-model" class="fs-sm-18 fs-16 text-black ff-dsm mb-2">Select Year</label>
                                        <Multiselect v-model="searchFilters.year" :options="$page.props.years" placeholder="Year"></Multiselect>
                                        <!-- <select id="select-model" class="form-select" v-model="searchFilters.year">
                                            <option selected value="">Year</option>
                                            <option v-for="year in $page.props.years">{{ year }}</option>
                                        </select> -->
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <div class="seperator">
                                        <label class="fs-sm-18 fs-16 text-black ff-dsm mb-2">Select Price</label>
                                        <div class="dropdown w-100">
                                            <button type="button" class="btn px-0 text-start w-100 fs-14 py-2" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                                RM {{ new Intl.NumberFormat('en-US').format(price[0]) }} - {{ new Intl.NumberFormat('en-US').format(price[1]) }}
                                            </button>
                                            <div class="dropdown-menu border-0 shadow-sm p-4 rounded-4">
                                                <div class="vstack gap-3">
                                                    <Slider class="mx-2 slider-primary" showTooltip="focus"
                                                        :format="{ decimals: 2, thousand: ',', }" :min="$page.props.prices.min"
                                                        :max="searchFilters.type === 'car-for-rent' ? $page.props.prices.all_rent_max : $page.props.prices.all_max" v-model="price" />

                                                    <div class="hstack gap-2">
                                                        <div class="border p-2 text-nowrap rounded-3 min-h-auto fs-15 min-w-150">RM
                                                            {{ new Intl.NumberFormat('en-US').format(price[0]) }}</div>
                                                        <div class="">-</div>
                                                        <div class="border p-2 text-nowrap rounded-3 min-h-auto fs-15 min-w-150">RM
                                                            {{ new Intl.NumberFormat('en-US').format(price[1]) }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <div class="seperator">
                                        <label for="select-body" class="fs-sm-18 fs-16 text-black ff-dsm mb-2">Select Body</label>
                                        <Multiselect v-model="searchFilters.body" :options="$page.props.bodies" placeholder="Body"></Multiselect>
                                        <!-- <select id="select-body" class="form-select" v-model="searchFilters.body">
                                            <option selected value="">Body</option>
                                            <option v-for="body in $page.props.bodies">{{ body.title }}</option>
                                        </select> -->
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <div class="seperator">
                                        <label for="select-location" class="fs-sm-18 fs-16 text-black ff-dsm mb-2">Select Location</label>
                                        <Multiselect v-model="searchFilters.location" :options="$page.props.locations" placeholder="Location"></Multiselect>
                                        <!-- <select id="select-location" class="form-select" v-model="searchFilters.location">
                                            <option selected>Location</option>
                                            <option v-for="(location, key) in $page.props.locations" :value="key">{{ location }}</option>
                                        </select> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-footer shadow-sm p-3 d-lg-none border-top border-plaster">
                            <button type="submit" class="btn-gradient-primary rounded-3 btn py-2 fs-15 px-5 w-100" data-bs-dismiss="offcanvas" data-bs-target="#search-filter" :disabled="searchFilters.processing">Apply <i v-if="searchFilters.processing" class="fad fa-spinner-third fa-spin"></i></button>
                        </div>
                    </div>
                </div>
                <div class="col-xl-auto align-self-center text-center">
                    <button type="submit" class="btn btn-gradient-primary fs-15 px-5 py-3 rounded-4" :disabled="searchFilters.processing"><i class="fal fa-search me-2"></i>Search <i v-if="searchFilters.processing" class="fad fa-spinner-third fa-spin"></i></button>
                </div>
            </div>
        </div>
    </form>
</template>

<script setup>
import { useForm, router, usePage, Link } from '@inertiajs/vue3';
import Slider from '@vueform/slider';
import Multiselect from '@vueform/multiselect';
import { ref } from 'vue';
import axios from 'axios';

const page = usePage();
const models = ref(page.props.models);
const price = ref([page.props.ziggy.query.min_price ?? page.props.prices.min, page.props.ziggy.query.max_price ?? page.props.prices.all_max]);

const searchFilters = useForm({
    keyword: page.props.ziggy.query.keyword ?? [],
    year: page.props.ziggy.query.year ?? [],
    min_price: price.value[0],
    max_price: price.value[1],
    // enable for url param
    model: page.props.ziggy.query.model ?? [],
    make: page.props.ziggy.query.make ?? [],
    body: page.props.ziggy.query.body ?? [],
    location: page.props.ziggy.query.location ?? [],
    type: page.props.ziggy.query.type ?? [],
})

function makesSelect(id){
    axios.post(route('front.get-models'), { make: id })
    .then((res) => {
        models.value = res.data
        searchFilters.model = null;
    })
    .catch((err) => {
        console.log(err);
    })
}

function makesClear(){
    searchFilters.model = null;
    models.value = null;
}

function submit() {

    searchFilters.min_price = price.value[0];
    searchFilters.max_price = price.value[1];

    searchFilters.get(route('front.vehicles.index'))
}

function changeVehicleType(){
    price.value[0] = 0;

    if(searchFilters.type === 'car-for-rent'){
        price.value[1] = page.props.prices.all_rent_max;
    }else{
        price.value[1] = page.props.prices.all_max;
    }
}
</script>

<style>
    @import '../../../../node_modules/@vueform/multiselect/themes/default.css';
</style>
